export default __webpack_public_path__ + "static/media/img60.197861a1.jpg";